import { render, staticRenderFns } from "./iconP3.vue?vue&type=template&id=5a98a31b&scoped=true&"
import script from "./iconP3.vue?vue&type=script&lang=js&"
export * from "./iconP3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a98a31b",
  null
  
)

export default component.exports